import * as ValidateModel from '../../shared/ValidateModel';

class GraphicTag {
    readonly id: number;

    readonly name: string;

    readonly idParent: number;

    constructor(id: number, name: string, idParent: number) {
        ValidateModel.isNumber(id, 'id');
        ValidateModel.isString(name, 'name');
        ValidateModel.isNumber(idParent, 'idParent');

        this.id = id;
        this.name = name;
        this.idParent = idParent;
    }

    getId = (): number => this.id;

    getName = (): string => this.name;

    getIdParent = (): number => this.idParent;
}

export default GraphicTag;
